module.exports = {"321311001":"顺河街道","321311002":"豫新街道","321311003":"下相街道","321311004":"晓店街道","321311005":"井头街道","321311006":"陆集街道","321311105":"仰化镇","321311106":"大兴镇","321311108":"来龙镇","321311111":"关庙镇","321311113":"新庄镇","321311151":"皂河镇","321311201":"曹集乡","321311401":"宿豫经济开发区","321311402":"宿迁生态化工科技产业园","321311403":"张家港宿豫工业园","321311450":"嶂山林场","321311451":"宿迁市软件与服务外包产业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321311.json
// module id = 1036
// module chunks = 0